import client from "apis/config";

export const getSignUrl = async (imageType) => {
  return await client.get(`files/s3/${imageType}`);
};
